<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="90vw"
  >
    <v-card>
      <v-card-title class="d-flex align-start justify-space-between">
        <p>{{ title }}</p>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="better-scrollbar">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                v-model="object.name"
                :label="$t('users.name')"
                :disabled="!isEditting"
                outlined
                dense
                rounded
                :error="hasErrors('name')"
                :error-messages="getErrors('name')"
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                v-model="object.username"
                :disabled="!isEditting"
                :label="$t('users.username')"
                outlined
                dense
                rounded
                :error="hasErrors('username')"
                :error-messages="getErrors('username')"
              />
            </v-col>
            <v-col cols="12" md="4" class="pa-2">
              <v-text-field
                v-model="object.email"
                :disabled="!isEditting"
                :label="$t('users.email')"
                prepend-inner-icon="mdi-email"
                outlined
                dense
                rounded
                :error="hasErrors('email')"
                :error-messages="getErrors('email')"
              />
            </v-col>
            <v-col cols="12" sm="4" class="pa-2">
              <v-text-field
                v-model="object.password"
                :disabled="!isEditting"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('users.password')"
                :type="show ? 'text' : 'password'"
                outlined
                dense
                rounded
                @click:append="show = !show"
                :error="hasErrors('password')"
                :error-messages="getErrors('password')"
              />
            </v-col>
            <v-col cols="12" md="4" class="pa-2">
              <v-autocomplete
                v-model="object.kind"
                :disabled="!isEditting"
                :label="$t('users.kind')"
                :items="usersKinds"
                item-text="name"
                item-value="value"
                outlined
                dense
                rounded
                :error="hasErrors('kind')"
                :error-messages="getErrors('kind')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          v-if="isEditting"
          @click="discardItem"
          small
          :ripple="false"
          outlined
          class="text-capitalize"
          dark
          color="primary"
        >
          {{ $t('actions.discard') }}
        </v-btn>
        <v-btn
          v-if="isEditting"
          @click="saveItem(object.id)"
          small
          :ripple="false"
          depressed
          class="text-capitalize"
          color="primary"
        >
          {{ $t('actions.save') }}
        </v-btn>
        <v-btn
          v-if="!isEditting"
          @click="isEditting = true"
          small
          :ripple="false"
          depressed
          class="text-capitalize"
          color="orange darken-1 white--text"
        >
          {{ $t('actions.edit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { orm } from '@/mixins'
import addMutation from '@/graphql/mutations/users/add.gql'
import editMutation from '@/graphql/mutations/users/edit.gql'

export default {
  model: {
    prop: 'data',
    event: 'set-object'
  },

  mixins: [orm],

  props: {
    showDialog: { type: Boolean, default: () => false },
    data: { type: Object, default: () => {} },
    isEditting: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      objectMap: {
        location: ''
      },
      show: false,
      errors: {}
    }
  },

  computed: {
    ...mapState(['isDark', 'users', 'workshops']),
    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('toggle-object', value)
      }
    },

    dialog: {
      get () {
        return this.showDialog
      },

      set (value) {
        this.$emit('toggle-dialog', value)
      }
    },

    title () {
      return this.object.id === null ? this.$i18n.t('users.new') : this.$i18n.t('users.edit')
    },

    usersKinds () {
      return [
        { value: 'ADMIN', name: this.$i18n.t('users.kinds.admin') },
        { value: 'OPERATOR', name: this.$i18n.t('users.kinds.operator') },
        { value: 'SUPERVISOR', name: this.$i18n.t('users.kinds.supervisor') }
      ]
    }
  },

  watch: {},

  created () {
    console.log('hola')
  },

  methods: {
    async saveItem (id) {
      this.isLoading = true
      const data = {
        id: id,
        name: this.object.name,
        username: this.object.username,
        email: this.object.email,
        password: this.object.password,
        kind: this.object.kind
      }
      if (id) {
        await this.edit(data)
      } else {
        await this.add(data)
      }
    },

    evaluateResponse ({ status, errors, result, action }) {
      this.isLoading = false
      console.log(status, errors)
      switch (status) {
        case 'OK':
          this.discardItem()
          this.resetErrors()
          this.$store.commit('toggleSnackbar', {
            color: 'green darken-2',
            message: this.$t('helpers.save.success')
          })
          if (action === 'add') {
            this.$store.dispatch('users/getList', true)
          }
          break
        case 'UNPROCESSABLE':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'BADREQUEST':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'LIMITREACHED':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.limit_reached')
          })
          break
      }
    },

    add (data) {
      const action = 'add'
      this.$apollo.mutate({
        mutation: addMutation,
        variables: {
          apiToken: this.users.entity.apiToken,
          data
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.addUser
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('[Devices Dialog] Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    edit (data) {
      const action = 'edit'
      this.$apollo.mutate({
        mutation: editMutation,
        variables: {
          apiToken: this.users.entity.apiToken,
          data
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.editUser
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('[Devices Dialog] Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    discardItem () {
      this.dialog = false
      this.object = Object.assign({}, this.$store.getters['users/defaultObject'])
      this.resetErrors()
    }
  }
}
</script>
